module.exports = __webpack_public_path__ + "static/media/ananya_d.51ab8896.jpeg";